import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { ErrorType } from 'modules/shared/models/error.models';
import * as error from 'store/actions/error.actions';
var initialState = {
    screeningErrors: {}
};
export function reducer(state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case error.ErrorActionTypes.SET_SCREENING_ERROR: {
            var newState = Object.assign({}, state);
            var errorOfThisRecord = newState.screeningErrors[action.payload.recordId];
            if (errorOfThisRecord) {
                if (errorOfThisRecord.data.failedSearches.indexOf(action.payload.searchEngineType) < 0) {
                    errorOfThisRecord.data.failedSearches.push(action.payload.searchEngineType);
                }
            }
            else {
                errorOfThisRecord = {
                    type: ErrorType.SCREENING_ERROR,
                    data: {
                        recordId: action.payload.recordId,
                        failedSearches: [action.payload.searchEngineType]
                    }
                };
            }
            return tslib_1.__assign({}, state, { screeningErrors: tslib_1.__assign({}, state.screeningErrors, (_a = {}, _a[errorOfThisRecord.data.recordId] = errorOfThisRecord, _a)) });
        }
        case error.ErrorActionTypes.REMOVE_SCREENING_ERROR: {
            var newState = Object.assign({}, state);
            if (newState.screeningErrors) {
                var errorOfThisRecord = newState.screeningErrors[action.payload.recordId];
                if (errorOfThisRecord) {
                    errorOfThisRecord.data.failedSearches = errorOfThisRecord.data.failedSearches
                        .filter(function (searchEngine) { return searchEngine !== action.payload.searchEngineType; });
                    if (errorOfThisRecord.data.failedSearches.length === 0) {
                        delete newState.screeningErrors[action.payload.recordId];
                    }
                }
            }
            return tslib_1.__assign({}, state, { screeningErrors: tslib_1.__assign({}, newState.screeningErrors) });
        }
        default: {
            return state;
        }
    }
}
var errorSelector = function (state) { return state.error; };
var ɵ0 = errorSelector;
var ɵ1 = function (state) { return state.screeningErrors; };
export var Selectors = {
    getScreeningErrors: createSelector(errorSelector, ɵ1),
};
export { ɵ0, ɵ1 };
